import { AppHeaderTheme } from '@app/core/layout/app-header/app-header-theme.model';
import { RouteConfig } from '@app/core/models';
import { NotificationPrefsHeaderComponent } from './notification-prefs-header.component';

export const NotificationsRouteConfig: RouteConfig = {
  headerConfig: {
    theme: AppHeaderTheme.Default,
    labelKey: 'NOTIFICATION-PREFERENCES.COMMUNICATIONS',
    hideMenu: true,
    contentComponent: () => NotificationPrefsHeaderComponent
  },
  hideNavigation: true
};
